import React, { useContext } from "react";
import { Grid, Form, Header } from "semantic-ui-react";
import FilterPageContext from "./FilterPageContext";

function Filters() {
    const ctx = useContext(FilterPageContext);

    let data: { key: string; value: any }[] = [];
    if (ctx.filters.receiptStatus) data.push({ key: "receiptStatus", value: ctx.filters.receiptStatus });
    if (ctx.filters.requestStatus) data.push({ key: "requestStatus", value: ctx.filters.requestStatus });
    return (
        <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                {/* <Header as="h4">Filter</Header> */}
            </div>
            <Grid columns={5}>
                <Grid.Row verticalAlign="bottom">
                    <Grid.Column>
                            <Form.Input
                                type="date"
                                label="From Date"
                                value={ctx.filters.startDate}
                                onChange={(_, { value }) =>
                                    ctx.filters.setStartDate(value)
                                }
                            />
                    </Grid.Column>

                    <Grid.Column>
                        <div>
                            <label>To Date</label>
                            <Form.Input
                                type="date"
                                value={ctx.filters.endDate}
                                onChange={(_, { value }) =>
                                    ctx.filters.setEndDate(value)
                                }
                            />
                        </div>
                    </Grid.Column> 

                    <Grid.Column>
                        <Form.Dropdown
                            label="Select Request Status"
                            search
                            selection
                            placeholder="Select Request Status"
                            options={ctx.options.requestStatusData}
                            value={ctx.filters.requestStatus}
                            onChange={(_, { value }) =>
                                ctx.filters.setRequestStatus(value as string)
                            }
                        />
                    </Grid.Column>

                    <Grid.Column>
                        <Form.Dropdown
                            label="Select Receipt Status"
                            search
                            selection
                            placeholder="Select Receipt Status"
                            options={ctx.options.receiptStatusData}
                            value={ctx.filters.receiptStatus}
                            onChange={(_, { value }) =>
                                ctx.filters.setReceiptStatus(value as string)
                            }
                        />
                    </Grid.Column>

                    <Grid.Column
                        style={{
                            display: "flex",
                            alignItems: "flex-end"
                        }}
                    >
                        <div className="ui buttons">
                            <button
                                className="ui blue button"
                                onClick={ctx.filters.applyFilters}
                            >
                                Apply Filters
                            </button>

                            <button
                                className="ui button"
                                onClick={ctx.filters.clearAllFilters}
                            >
                                Clear
                            </button>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </>
    );
}

export default Filters;
